<template>
  <v-card
    v-bind:class="{ archived: esignature.archived, hidden: (!viewArchived && esignature.archived), handle: true }"
    style="margin-bottom:20px;cursor:pointer;"
  >
    <v-toolbar
      dense
      flat
      style="position:relative;"
    >
        <v-icon>
          mdi-signature
        </v-icon>
        &nbsp;&nbsp;
        <b style="margin-right: 50px;">Signature Field</b>
        <div>
          <v-chip 
            outline
            color="grey"
            small
            v-if="conditional_part"  
          >
            Conditional
          </v-chip>
          <v-chip 
            outline
            color="grey"
            small
            v-if="esignature.pdf_only"  
          >
            PDF Only
          </v-chip>
        </div>
        <ArchiveButton
          style="float:right;position:absolute;right:15px;top:12px;"
          :archived="esignature.archived"
          @restore="restore()"
          @archive="archive()"
        />
    </v-toolbar>
  </v-card>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import ArchiveButton from './ArchiveButton'

export default {
  name: 'FormTemplateEsignature',
  props: [ 'partId', 'newPart' ],
  components: {
    ArchiveButton
  },
  data () {
    return {
      loading: false,
      conditional_part: false
    }
  },
  computed: {
    ...mapGetters('formtemplate', [
      'partById',
    ]),
    ...mapState('formtemplate', [
      'viewArchived',
      'viewIdentifiers'
    ]),
    esignature () {
      return this.partById(this.partId) || this.newPart
    }
  },
  created () {
    this.conditional_part = (this.esignature.conditional_question_id)
  },
  methods: {
    ...mapActions('formtemplate', [
      'saveEsignature'
    ]),
    archive () {
      this.loading = true
      this.esignature.archived = true
      this.saveEsignature(this.esignature)
      .then(signature => {
        this.$emit('save', signature)
        this.loading = false
      })
    },
    restore () {
      this.loading = true
      this.esignature.archived = false
      this.saveEsignature(this.esignature)
      .then(signature => {
        this.$emit('save', signature)
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.question-edit-button {
  margin-left: 10px;
}

.inlineLimiter >>> :first-child {
  display:inline;
}
</style>
